import * as React from 'react';
import { FilterIcon } from 'lucide-react';
import { cn } from 'lib/utils';
import { PageHeaderForFiltersContext } from './context';

type Props = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'>;

export const FiltersToggleButton = ({ ...props }: Props) => {
  const { open, setOpen } = React.useContext(PageHeaderForFiltersContext);

  const toggleOpen = () => {
    setOpen((open) => !open);
  };

  return (
    <button onClick={toggleOpen} {...props}>
      <FilterIcon
        className={cn(
          'h-4 w-4 text-[#1E293B] fill-none',
          open && 'fill-[#1E293B]'
        )}
      />
    </button>
  );
};
